
    import '/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-react-model-use-qwen-demo-qwen-sdk","docs-react-model-use-qwen-demo-qwen"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/react/model-use-qwen.en-US.md?type=demo')
};